/**
 * External dependencies
 */
import { combineReducers } from 'redux';
import { reduce, get, omit } from 'lodash';

/**
 * Internal dependencies
 */
import { createReducer } from 'state/utils';
import {
    COUPONS_RECEIVE,
    COUPONS_REQUEST,
    COUPONS_REQUEST_SUCCESS,
    COUPONS_REQUEST_FAILURE
} from 'state/action-types';

export const items = createReducer([], {
    [COUPONS_RECEIVE]: (state, action) => {
        return reduce(
            action.payload.items,
            (memo, coupon) => {
                const { id } = coupon;
                if (memo === state) {
                    memo = { ...memo };
                }
                memo[id] = coupon;
                return memo;
            },
            state,
        );
    },
});

export const requesting = createReducer(false, {
    [COUPONS_REQUEST]: () => true,
    [COUPONS_REQUEST_SUCCESS]: () => false,
    [COUPONS_REQUEST_FAILURE]: () => false,
});

export const error = createReducer(false, {
    [COUPONS_REQUEST]: () => false,
    [COUPONS_REQUEST_SUCCESS]: () => false,
    [COUPONS_REQUEST_FAILURE]: () => true,
});

export default combineReducers({
    items,
    requesting,
    error
});
